import { getLocalVariable, removeLocalVariable, setSessionVariable } from '@services/storage';

import { IRudiApiRechercherAdresse } from '@app-types/eligibility';

export function getStoredGcpData(): IRudiApiRechercherAdresse {
    return JSON.parse(getLocalVariable('eligibility_gcp_data') ?? '{}');
}

export function removeStoredGcpData() {
    removeLocalVariable('eligibility_gcp_data');
}

export function setThreeClicsStorage(data: { data: boolean; expiresTimestamp: number | null }) {
    setSessionVariable('ftth3Clics', JSON.stringify(data));
}
